module.exports = new __parcel__URL__("refreshingleaves.78506314.png").toString();